import { bookingOrderApi } from "src/services/api";
import { isRoundTrip } from "src/utils/results-utils";
import { getSelectedLocale } from "src/utils/storage-utils";

import { isLangAbsent, redirectWithLang } from "./utils/loader-utils";

function formatFlightDate(timestampSeconds, lang) {
  const date = new Date(timestampSeconds * 1000);
  const options = {
    day: "2-digit",
    month: "short",
  };
  const formattedDate = new Intl.DateTimeFormat(lang, options).format(date);
  return formattedDate;
}

export const IMG_SIZES = {
  xxsmall: "80x80",
  xsmall: "100x100",
  small: "326x220",
  small2: "295x220",
  medium: "640x400",
  large: "828x560",
  larger: "x768",
  thumbMob: "170x154",
}

function formatDataItem(trip, lang, i) {
  // Preserve bookingType and hotel data from API
  const bookingType = trip.bookingType; // 'flight' or 'hotel'
  const hotel = trip.hotel;

  trip.tripType = isRoundTrip(trip) ? "roundtrip" : "oneway";
  trip.from = trip.segments[0].dep.city.title?.split(",")[0];
  const destination = trip.segments_direction[0].at(-1);
  trip.to = trip.segments[destination].arr.city.title?.split(",")[0];
  const startDateStr = formatFlightDate(trip.segments[0].dep.timestamp, lang);
  const endDateStr = formatFlightDate(trip.segments.at(-1).arr.timestamp, lang);
  trip.dates =
    trip.tripType === "roundtrip" ? `${startDateStr} - ${endDateStr}` : startDateStr;

  // Set imageUrl based on booking type
  if (bookingType === "hotel" && hotel?.image) {
    trip.imageUrl = hotel.image?.replace("{size}", IMG_SIZES.small); // 250 x 175 original
  } else {
    trip.imageUrl =
      `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
      `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/cities/` +
      `${trip.segments[destination].arr.city.code}.jpg`;
  }

  trip.paid = trip.amountPaid >= trip.totalBookingPrice;

  // Restore bookingType and hotel
  if (bookingType) trip.bookingType = bookingType;
  if (hotel) trip.hotel = hotel;

  return trip;
}

export async function loader({ request, user }) {
  console.log("userTripsLoader");
  if (isLangAbsent(request)) return redirectWithLang(request);
  const url = new URL(request.url);
  const searchParams = url.searchParams;

  const lang = searchParams.get("lang") || getSelectedLocale().split("_")[0];
  if (!user) return null;

  const allTrips = bookingOrderApi
    .getUserTrips(user.uid)
    .then((allTripsRes) => {
      const allTrips = allTripsRes.data;
      allTrips.forEach((trip, i) => formatDataItem(trip, lang, i));
      const [trips, pastTrips] = allTrips.reduce(
        (acc, trip) => {
          const targetArr = trip.segments[0].dep.timestamp * 1000 < Date.now() ? 1 : 0;
          if (targetArr === 1) trip.past = true;
          acc[targetArr].push(trip);
          return acc;
        },
        [[], []]
      );

      trips.sort((a, b) => a.segments[0].dep.timestamp - b.segments[0].dep.timestamp);
      pastTrips.sort((a, b) => b.segments[0].dep.timestamp - a.segments[0].dep.timestamp);
      console.log(trips);
      console.log(pastTrips);
      return [trips, pastTrips];
    })
    .catch((err) => {
      console.log(err);
      if (err.response?.status === 404) {
        return [[], []];
      }
      throw Response.json({ data: err });
    });

  return { allTrips };
}
